





























import {Component, Mixins} from 'vue-property-decorator';
import AmountMixin from '@/components/claim/popup/mixins/AmountMixin';

// 혜택재계산(J)
@Component
export default class BenefitRecalculate extends Mixins(AmountMixin){
  private accumulation = {
    totalAccumulationAmt: 0,
    beforeAccumulationAmt: 0,
    afterAccumulationAmt: 0,
  }

  created(){
    this.setAccumulation()
  }

  setAccumulation(){
    this.accumulation.beforeAccumulationAmt = this.amounts.before.accumulation.accumulationAmt
    this.accumulation.afterAccumulationAmt = this.amounts.after.accumulation.accumulationAmt
    this.accumulation.totalAccumulationAmt = this.accumulation.afterAccumulationAmt - this.accumulation.beforeAccumulationAmt
  }
}
